export default {
    ConnectTenant: {
        TitleForm: "Chọn dữ liệu",
        TenantWork: "Đơn vị đang làm việc",
        ManagerTenant: "Quản lý đơn vị",
        InputLabel: "Chọn đơn vị khác",
        InputPlaceHolder: "Nhập mã QHNS",
        DataTenant: "Dữ liệu",
        ManagerDataTenant: "Quản lý dữ liệu",
    },

    ButtonName: {
        Cancel: "Hủy bỏ",
        Save: "Đồng ý"
    }
}